import { defineComponent } from "vue";
import { mapState } from "pinia";

import { useCreateReferralHosPal } from "../../store/useCreateReferralHosPal";

import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import CommentInput from "../../../../../resources-vue/vue-custom-elements/CommentInput/CommentInput.vue";

export default defineComponent({
    components: {
        FormSection,
        CommentInput
    },

    props: {
        referral: {
            default: null
        }
    },

    computed: {
        ...mapState(useCreateReferralHosPal, { patient: "referral" })
    },

    data() {
        return {
            popoverContent:
                "This section can be updated each time the patient identifies a new goal. To save a snapshot of this information, sign the plan of care."
        };
    },

    methods: {
        resultPersonalGoalsAppended(value: string) {
            this.patient.personalGoals += value;
        },
        resultPersonalGoals(value: string) {
            this.patient.personalGoals = value;
        },
        resultCareGoalsAppended(value: string) {
            this.patient.careGoals += value;
        },
        resultCareGoals(value: string) {
            this.patient.careGoals = value;
        },
        resultBarriersGoalsAppended(value: string) {
            this.patient.barriersToPersonalOrCareGoals += value;
        },
        resultBarriersGoals(value: string) {
            this.patient.barriersToPersonalOrCareGoals = value;
        }
    }
});
